import React, { forwardRef } from "react";
import Snackbar, { SnackbarProps } from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import Slide from "@mui/material/Slide";

type CustomSnackbarProps = SnackbarProps & {
  children: React.ReactNode;
};

const CustomSnackbar = forwardRef(function CustomSnackbar(
  props: CustomSnackbarProps,
  ref: React.Ref<any>
) {
  return (
    <Snackbar {...props} TransitionComponent={Slide} anchorOrigin={{vertical: "bottom", horizontal: "center"}} ref={ref}>
      {props.children}
    </Snackbar>
  );
});

type CustomAlertProps = AlertProps & {
  children: React.ReactNode;
};

const CustomAlert = forwardRef(function CustomAlert(
  props: CustomAlertProps,
  ref: React.Ref<any>
) {
  const { onClose, severity } = props;
  return (
    <Alert onClose={onClose} severity={severity} variant="filled" sx={{ minWidth: "300px"}} ref={ref}>
      {props.children}
    </Alert>
  );
});

export { CustomSnackbar, CustomAlert };